<template>
	<div class="bright container-fluid py-4">
		<router-view @childrenRoute="hideNonChildren" />

		<div v-if="!isChildRoute">
			<div class="row">
				<div class="col-md-12">
					<div class="d-flex align-items-center">
						<div class="mr-2">
							<div style="font-size: 20px;">TREASURY SUMMARY</div>
							<div  v-if="false">
								<span class="demonstration">Filter: </span>
								<el-cascader
									size="medium"
									ref="cascader"
									:options="options"
									:props="props"
									collapse-tags
									clearable
									@change="handleCascaderChange">
									<template slot-scope="{ node, data }">
										<span>{{ data.label }}</span>
										<span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
									</template>
								</el-cascader>
							</div>
						</div>
						<div class="ml-auto">
							<!--<el-button type="primary" size="small" icon="el-icon-search" v-on:click="filterModal">Filter</el-button>-->
							<el-button type="primary" size="small" icon="el-icon-search" @click="filterDrawer = true" style="margin-left: 16px;">Filter</el-button>
						</div>	
					</div>	
				</div>	
			</div>

			<div class="row">
				
				<div class="col-md-12">
					<div class="row mt-4">
						<div class="col-md-4 mb-4">
							<el-card shadow="hover">
								<PosisiSaldo />
							</el-card>
						</div>
						<div class="col-md-4 mb-4">
							<el-card shadow="hover">
								<CashFlow />
							</el-card>
						</div>
						<div class="col-md-4 mb-4">
							<el-card shadow="hover">
								<CashNonCash />							
							</el-card>
						</div>
					</div>
				</div>

				<div class="col-md-12">
					<div class="row">
						<div class="col-md-12 mb-4">
							<el-card shadow="hover">
								<FinancialRatio />
							</el-card>
						</div>
					</div>
				</div>

				<div class="col-md-12">
					<div class="row">
						<div class="col-md-12 mb-4">
							<el-card shadow="hover">
								<OutstandingLoan />
							</el-card>
						</div>
					</div>
				</div>

				<div class="col-md-12">
					<div class="row">
						<div class="col-md-12 mb-4">
							<el-card shadow="hover">
								<PendapatanBunga />
							</el-card>
						</div>
					</div>
				</div>

				<div class="col-md-12">
					<div class="row">
						<div class="col-md-12 mb-4">
							<el-card shadow="hover">
								<PembayaranBunga />
							</el-card>
						</div>
					</div>
				</div>

				<div class="col-md-12">
					<div class="row">
						<div class="col-md-12 mb-4">
							<el-card shadow="hover">
								<CashFlowDetail />
							</el-card>
						</div>
					</div>
				</div>
				
				<div class="mb-4 mt-4" v-if="filterParam.comparisonChartVisibility && this.filterParam.dataType=='total' ">
					<el-card class="box-card col-md-12">
						<div slot="header" class="clearfix">
							<span><strong>PERBANDINGAN PENJUALAN & PENGELUARAN</strong></span>
						</div>
						<div>
							<LineChart v-loading.body="loading.comparison" :data="this.comparisonChart" :height="200" :width="500"/>
							<!-- generateComparisonChart() -->
						</div>
					</el-card>
				</div>
				

				<div class="mb-4 mt-4" v-if="tabChart.visible">
					<el-card class="box-card col-md-12">
						<div slot="header" class="clearfix">
							<span><strong>SUMMARY PENERIMAAN</strong></span>
						</div>
						<div>
							<el-tabs v-model="tabChartPenerimaanActiveName" @tab-click="handleClickTabChartPenerimaan">
								<el-tab-pane label="Penjualan" name="tabChartPenerimaanPenjualan">
									<BarChart v-if="tabChart.tab1" :data="ytd.summary.penerimaan.barchart_penjualan" :width="barChartSize.width" :height="barChartSize.height"/>
								</el-tab-pane>
								<el-tab-pane label="Bunga Deposito" name="tabChartPenerimaanBungaDeposito">
									<BarChart v-if="tabChart.tab2" :data="ytd.summary.penerimaan.barchart_bunga_deposito" :width="barChartSize.width" :height="350" />
								</el-tab-pane>
								<el-tab-pane label="Bunga Notpool" name="tabChartPenerimaanBungaNotpool">
									<BarChart v-if="tabChart.tab3" :data="ytd.summary.penerimaan.barchart_bunga_notpool" :width="barChartSize.width" :height="350" />	
								</el-tab-pane>
								<el-tab-pane label="Bunga Giro" name="tabChartPenerimaanBungaGiro">
									<BarChart v-if="tabChart.tab4" :data="ytd.summary.penerimaan.barchart_bunga_giro" :width="500" :height="550" />
								</el-tab-pane>
							</el-tabs>
						</div>
					</el-card>
				</div>


				<div class="mt-4" v-if="kategori.penerimaan.checked.length > 0">
					<H6 class="title-section">SUMMARY PENERIMAAN</H6>
				</div>
				<div class="col-md-12">
					<BarCard title="A. PENJUALAN" v-if="isExistInArray(kategori.penerimaan.checked,'Penjualan')" :data="ytd.summary.penerimaan.barchart_penjualan" :width="500" :height="500" url="/treasury"/>
				</div>

				<div class="col-md-12">
					<BarCard title="B. BUNGA DEPOSITO" v-if="isExistInArray(kategori.penerimaan.checked,'Bunga Deposito')" :data="ytd.summary.penerimaan.barchart_bunga_deposito" :width="500" :height="500" url="/treasury"/>
				</div>

				<div class="col-md-12">
					<BarCard title="C. BUNGA NOTPOOL" v-if="isExistInArray(kategori.penerimaan.checked,'Bunga Notpool')" :data="ytd.summary.penerimaan.barchart_bunga_notpool" :width="500" :height="500" url="/treasury"/>
				</div>

				<div class="col-md-12">
					<BarCard title="D. BUNGA GIRO" v-if="isExistInArray(kategori.penerimaan.checked,'Bunga Giro')" :data="ytd.summary.penerimaan.barchart_bunga_giro" :width="500" :height="550" url="/treasury"/>
				</div>


				<div class="" v-if="kategori.persentasePenerimaan.checked.length > 0">
					<H6 class="title-section">SUMMARY PERSENTASE PENERIMAAN</H6>
				</div>
				<div class="col-md-12">
					<BarCard title="PENJUALAN" v-if="isExistInArray(kategori.persentasePenerimaan.checked,'Penjualan')" :data="ytd.summary.penerimaan_persentase.barchart_penjualan" :width="500" :height="350" url="/treasury"/>
				</div>
				<div class="col-md-12" v-show="false" v-if="isExistInArray(kategori.persentasePenerimaan.checked,'Penjualan')">
					<div class="row">
						<div class="col-md-4" v-for="(item, key, index) in ytd.summary.piechart_penerimaan_persentase.penjualan" :key="item+'_'+index">

							<div class="card cardptpr mb-4">
								<div class="card-header cardptpr p-3 pb-0 pt-0">
									<H6>PENJUALAN   </H6> <!-- {{ item[0].Tahun }}-->
								</div>
								<div class="card-body p-3 pt-0" style="width:100%;">
									<PieChart :data="pieChartData2(item)"
										:url="'/treasury?tab=2&'"/> <!-- pieChartPenerimaanData(item)-->
								</div>
							</div>
							
						</div>
					</div>
				</div>

				<div class="col-md-12">
					<BarCard title="CASH" v-if="isExistInArray(kategori.persentasePenerimaan.checked,'Cash')" :data="ytd.summary.penerimaan_persentase.barchart_cash" :width="500" :height="350" url="/treasury"/>
				</div>
				<div class="col-md-12">
					<BarCard title="NON CASH" v-if="isExistInArray(kategori.persentasePenerimaan.checked,'Non Cash')" :data="ytd.summary.penerimaan_persentase.barchart_non_cash" :width="500" :height="350" url="/treasury"/>
				</div>
				<div class="col-md-12">
					<BarCard title="CASH PER DAY" v-if="isExistInArray(kategori.persentasePenerimaan.checked,'Cash Per Day')" :data="ytd.summary.penerimaan_persentase.barchart_cash_per_day" :width="500" :height="350" url="/treasury"/>
				</div>
				<div class="col-md-12">
					<BarCard title="NON CASH PER DAY" v-if="isExistInArray(kategori.persentasePenerimaan.checked,'Non Cash Per Day')" :data="ytd.summary.penerimaan_persentase.barchart_non_cash_per_day" :width="500" :height="350" url="/treasury"/>
				</div>
				<div class="col-md-12">
					<BarCard title="RATA RATA PER DAY" v-if="isExistInArray(kategori.persentasePenerimaan.checked,'Rata Rata Per Day')" :data="ytd.summary.penerimaan_persentase.barchart_rata_rata_day" :width="500" :height="350" url="/treasury"/>
				</div>
				<div class="col-md-12" v-if="isExistInArray(kategori.persentasePenerimaan.checked,'Cash') && isExistInArray(kategori.persentasePenerimaan.checked,'Non Cash')">
					<div class="row">
						<div class="col-md-4" v-for="(value, key, index) in this.pieChartCashNonCashData" :key="'pie_chart_cnc_'+key+index">
							<div class="card cardptpr mb-4">
								<div class="card-header cardptpr p-3 pb-0 pt-0">
									<H6>CASH & NON CASH {{ key }}</H6>
								</div>
								
								
								<div class="card-body p-3 pt-0" style="width:100%;">
									<PieChart :data="pieChartData2(value)"
										:url="'/treasury?tab=2&'"/>
								</div>
								
							</div>
						</div>

						<!--
						<div class="col-md-3" v-for="(item, index) in ytd.summary.piechart_penerimaan_persentase.cash" :key="item+'_'+index">

							<div class="card cardptpr mb-4" v-if="isExistInArray(kategori.persentasePenerimaan.checked,'Cash')">
								<div class="card-header cardptpr p-3 pb-0 pt-0">
									<H6>CASH {{ item[0].Tahun }}</H6>
								</div>
								<div class="card-body p-3 pt-0" style="width:100%;">
									<PieChart :data="pieChartPenerimaanData(item)"
										:url="'/treasury?tab=2&'"/>
								</div>
							</div>
							
						</div>

						<div class="col-md-3" v-for="(item, index) in ytd.summary.piechart_penerimaan_persentase.non_cash" :key="item+index">

							<div class="card cardptpr mb-4" v-if="isExistInArray(kategori.persentasePenerimaan.checked,'Non Cash')">
								<div class="card-header cardptpr p-3 pb-0 pt-0">
									<H6>NON CASH {{ item[0].Tahun }}</H6>
								</div>
								<div class="card-body p-3 pt-0" style="width:100%;">
									<PieChart :data="pieChartPenerimaanData(item)"
										:url="'/treasury?tab=2&'"/>
								</div>
							</div>
							
						</div>
						-->
					</div>
				</div>
				

				<div class="" v-if="(kategori.pengeluaran.checked.length > 0)">
					<H6 class="title-section">SUMMARY PENGELUARAN</H6>
				</div>
				<div class="col-md-12">
					<BarCard title="A. PENGELUARAN" v-if="isExistInArray(kategori.pengeluaran.checked,'Pengeluaran')" :data="ytd.summary.pengeluaran.barchart_pengeluaran" :width="500" :height="650" url="/treasury"/>
				</div>
				<div class="col-md-12">
					<BarCard title="B. BIAYA ADMINISTRASI BANK" v-if="isExistInArray(kategori.pengeluaran.checked,'Biaya Administrasi Bank')" :data="ytd.summary.pengeluaran.barchart_biaya_administrasi_bank" :width="500" :height="600" url="/treasury"/>
				</div>
				<div class="col-md-12">
					<BarCard title="C. PAJAK NOTPOOL" v-if="isExistInArray(kategori.pengeluaran.checked,'Pajak Notpool')" :data="ytd.summary.pengeluaran.barchart_pajak_notpool" :width="500" :height="500" url="/treasury"/>
				</div>
				<div class="col-md-12">
					<BarCard title="D. PAJAK GIRO" v-if="isExistInArray(kategori.pengeluaran.checked,'Pajak Giro')" :data="ytd.summary.pengeluaran.barchart_pajak_giro" :width="500" :height="500" url="/treasury"/>
				</div>
				<div class="col-md-12">
					<BarCard title="E. BANK CHARGE" v-if="isExistInArray(kategori.pengeluaran.checked,'Bank Carge')" :data="ytd.summary.pengeluaran.barchart_bank_charge" :width="500" :height="500" url="/treasury"/>
				</div>

				<div class="" v-if="(kategori.persentasePengeluaran.checked.length > 0)">
					<H6 class="title-section">SUMMARY PERSENTASE PENGELUARAN</H6>
				</div>
				<div class="col-md-12" v-if="isExistInArray(kategori.persentasePengeluaran.checked,'Pengeluaran')">
					<BarCard title="PENGELUARAN" :data="ytd.summary.pengeluaran_persentase.barchart_pengeluaran" :width="500" :height="400" url="/treasury"/>
				</div>
<!--
				<div class="col-md-12" v-show="false" v-if="isExistInArray(kategori.persentasePengeluaran.checked,'Pengeluaran')">
					<div class="row">
						<div class="col-md-6" v-for="(item, key, index) in ytd.summary.piechart_pengeluaran_persentase.pengeluaran" :key="item+index">

							<div class="card cardptpr mb-4">
								<div class="card-header cardptpr p-3 pb-0 pt-0">
									<H6>PENGELUARAN  {{ key }}</H6>
								</div>
								<div class="card-body p-3 pt-0" style="width:100%;">
									<PieChart :data="pieChartData2(item)"
										:url="'/treasury?tab=2&'"/>
								</div>
							</div>
							
						</div>
					</div>
				</div>

				<div class="col-md-12" v-if="isExistInArray(kategori.persentasePengeluaran.checked,'Pengeluaran Per Bank')">
					<BarCard title="PENGELUARAN PER BANK" :data="ytd.summary.pengeluaran_persentase.barchart_pengeluaran_per_bank" :width="500" :height="400" url="/treasury"/>
				</div>

				<div class="col-md-12" v-if="isExistInArray(kategori.persentasePengeluaran.checked,'Pengeluaran Per Bank')">
					<div class="row">
						<div class="col-md-4" v-for="(item, key, index) in ytd.summary.piechart_pengeluaran_persentase.pengeluaran_per_bank" :key="item+index">

							<div class="card cardptpr mb-4">
								<div class="card-header cardptpr p-3 pb-0 pt-0">
									<H6>PENGELUARAN  PER BANK {{ key }}</H6>
								</div>
								<div class="card-body p-3 pt-0" style="width:100%;">
									<PieChart :data="pieChartData2(item)"
										:url="'/treasury?tab=2&'"/>
								</div>
							</div>
							
						</div>
					</div>
				</div>

				<div class="col-md-12" v-if="isExistInArray(kategori.persentasePengeluaran.checked,'Biaya Administrasi Bank')">
					<BarCard title="BIAYA ADMINISTRASI BANK" :data="ytd.summary.pengeluaran_persentase.barchart_biaya_administrasi_bank" :width="500" :height="400" url="/treasury"/>
				</div>

				<div class="col-md-12" v-if="isExistInArray(kategori.persentasePengeluaran.checked,'Biaya Administrasi Bank')">
					<div class="row">
						<div class="col-md-4" v-for="(item, key, index) in ytd.summary.piechart_pengeluaran_persentase.biaya_administrasi_bank" :key="item+index">

							<div class="card cardptpr mb-4">
								<div class="card-header cardptpr p-3 pb-0 pt-0">
									<H6>BIAYA ADMINISTRASI BANK {{ key }}</H6>
								</div>
								<div class="card-body p-3 pt-0" style="width:100%;">
									<PieChart :data="pieChartData2(item)"
										:url="'/treasury?tab=2&'"/>
								</div>
							</div>
							
						</div>
					</div>
				</div>

				<div class="col-md-12" v-if="isExistInArray(kategori.persentasePengeluaran.checked,'Pajak Giro')">
					<BarCard title="PAJAK GIRO" :data="ytd.summary.pengeluaran_persentase.barchart_pajak_giro" :width="500" :height="400" url="/treasury"/>
				</div>

				<div class="col-md-12" v-if="isExistInArray(kategori.persentasePengeluaran.checked,'Pajak Giro')">
					<div class="row">
						<div class="col-md-4" v-for="(item, key, index) in ytd.summary.piechart_pengeluaran_persentase.pajak_giro" :key="item+index">

							<div class="card cardptpr mb-4">
								<div class="card-header cardptpr p-3 pb-0 pt-0">
									<H6>PAJAK GIRO {{ key }}</H6>
								</div>
								<div class="card-body p-3 pt-0" style="width:100%;">
									<PieChart :data="pieChartData2(item)"
										:url="'/treasury?tab=2&'"/>
								</div>
							</div>
							
						</div>
					</div>
				</div>

			
				<div class="col-md-12" v-if="isExistInArray(kategori.persentasePengeluaran.checked,'Bank Charge')">
					<BarCard title="BANK CHARGE" :data="ytd.summary.pengeluaran_persentase.barchart_bank_charge" :width="500" :height="400" url="/treasury"/>
				</div>

				<div class="col-md-12" v-if="isExistInArray(kategori.persentasePengeluaran.checked,'Bank Charge')">
					<div class="row">
						<div class="col-md-4" v-for="(item, key, index) in ytd.summary.piechart_pengeluaran_persentase.bank_charge" :key="item+index">

							<div class="card cardptpr mb-4">
								<div class="card-header cardptpr p-3 pb-0 pt-0">
									<H6>BANK CHARGE {{ key }}</H6>
								</div>
								<div class="card-body p-3 pt-0" style="width:100%;">
									<PieChart :data="pieChartData2(item)"
										:url="'/treasury?tab=2&'"/>
								</div>
							</div>
							
						</div>
					</div>
				</div>
-->			

			</div>

			<div id="modal" class="modal fade " v-show="isModalVisible" aria-hidden="true">
				<div class="modal-dialog modal-dialog-centered" style="max-width:1080px;">
					<div class="modal-content">
						<div class="modal-header">
							<h5 class="modal-title">Filter</h5>
							<button type="button" class="close" v-on:click="closeModal">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
						<div class="modal-body">
							<div class="row">
								<div class="row col-md-12">
									<div class="col-md-6">
										<h6>Bulan</h6>
										<hr style="margin-top:0px;">
										<div class="row col-md-12" style="padding-left:20px;"> 
											<div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;" v-for="(item, index) in this.months" :key="item.Id+index">
												<input type="checkbox" class="custom-control-input" :id="'month-checkbox-'+item.Id" v-model="item.Grup" :checked="item.Grup" @change="handleChangeMonth(item, item.Grup)">
												<label class="custom-control-label" :for="'month-checkbox-'+item.Id">{{item.Name}}</label>
											</div> 
										</div>
									</div>
									<div class="col-md-6">
										<ReportParamSelect title="Tahun" name="year"  />

									</div>
								</div>

								<div class="col-md-12">
									<h6>Kategori</h6>
									<hr style="margin-top:0px;">
									<div class="row col-md-12" style="padding-left:20px;">   
										<div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
											<input type="checkbox" class="custom-control-input" id="checkbox-1" >
											<label class="custom-control-label" for="checkbox-1">Penjualan</label>
										</div>   
										<div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
											<input type="checkbox" class="custom-control-input" id="checkbox-2" >
											<label class="custom-control-label" for="checkbox-2">Bunga Depostio</label>
										</div>   
										<div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
											<input type="checkbox" class="custom-control-input" id="checkbox-3" >
											<label class="custom-control-label" for="checkbox-3">Bunga NOTPOOL</label>
										</div>   
										<div class="col-pg custom-control custom-checkbox checkbox-md" style="flex-grow:0;">
											<input type="checkbox" class="custom-control-input" id="checkbox-4">
											<label class="custom-control-label" for="checkbox-4">Bunga Giro</label>
										</div>    
									</div>                                                        
								</div>
							</div>
						</div>
						<div class="modal-footer">
							<button type="button" class="btn btn-secondary" v-on:click="closeModal">Cancel</button>
							<button type="button" class="btn btn-danger" v-on:click="closeModal">Apply</button>
						</div>
					</div>
				</div>
			</div>

			<TreasuryFilterDrawer 
				:filterDrawerVisibility="filterDrawer"
				@close-filter-drawer="handleCloseFilterDrawer"
				@apply-filter-change="handleApplyFilterDrawer($event)"
			/>
		</div>
	
	</div>
</template>

<script>
import Treasury from '@/components/page/Treasury.js'
import BarCard from '@/views/pages/BarCard.vue'
import BarChart from '@/components/chart/BarChart.js'
import PieChart from '@/components/chart/Pie.js'
import LineChart from '@/components/chart/LineChart.js'
import ListItem from '@/views/pages/ListItem.vue'
import ListCompare from '@/views/pages/ListCompare.vue'
import Footer from '@/views/Footer.vue'
import { Rainbow, Rainbow3, Config, AxiosWithJar } from '@/utility.js'
import ReportParamSelect from '@/views/pages/ReportParamSelect.vue'
import TreasuryFilterDrawer from '@/views/pages/TreasuryFilterDrawer.vue'
//import SoftButton from "@/components/SoftButton.vue";

//Component
import PosisiSaldo from '@/views/pages/Treasury/Summary/Component/PosisiSaldo.vue'
import CashFlow from '@/views/pages/Treasury/Summary/Component/CashFlow.vue'
import CashNonCash from '@/views/pages/Treasury/Summary/Component/CashNonCash.vue'
import FinancialRatio from '@/views/pages/Treasury/Summary/Component/FinancialRatio.vue'
import PendapatanBunga from '@/views/pages/Treasury/Summary/Component/PendapatanBunga.vue'
import PembayaranBunga from '@/views/pages/Treasury/Summary/Component/PembayaranBunga.vue'
import OutstandingLoan from '@/views/pages/Treasury/Summary/Component/OutstandingLoan.vue'
import CashFlowDetail from '@/views/pages/Treasury/Summary/Component/CashFlowDetail.vue'


import $ from 'jquery'

export default{
	extends: Treasury,
	components:{
		//ListItem,
		//ListCompare,
		ReportParamSelect,
		BarCard,
		PieChart,
		//Footer,
		TreasuryFilterDrawer,    
		LineChart,   
		BarChart,

		PosisiSaldo,
		CashFlow,
		CashNonCash,
		FinancialRatio,
		PendapatanBunga,
		PembayaranBunga,
		OutstandingLoan,
		CashFlowDetail,
	},
	mounted(){
		this.hideNonChildren();
		//this.loadData();
		//this.loadSummaryData();

		//new filter
		//this.loadMonths();
		//this.loadSummaryLabel();
		this.loadSummaryFilter('penerimaan', 'PENJUALAN', [], this.filterParam.dataType)
		this.loadSummaryFilter('penerimaan', 'BUNGA DEPOSITO', [], this.filterParam.dataType)
		this.loadSummaryFilter('penerimaan', 'BUNGA NOTPOOL', [], this.filterParam.dataType)
		this.loadSummaryFilter('penerimaan', 'BUNGA GIRO', [], this.filterParam.dataType)

		this.loadSummaryFilter('pengeluaran', 'PENGELUARAN', [], this.filterParam.dataType)
		this.loadSummaryFilter('persentase_penerimaan', 'PENJUALAN', [], this.filterParam.dataType)
		this.loadSummaryFilter('persentase_pengeluaran', 'PENGELUARAN', [], this.filterParam.dataType)

		this.loadSummaryPie('persentase_pengeluaran', 'PENGELUARAN', [], this.filterParam.dataType)
		this.loadSummaryPie('persentase_penerimaan', 'PENJUALAN', [], this.filterParam.dataType)
	},
	data() {
		return {
			isChildRoute: false,
			colors: ['#1F82E4','#F59B0E','#FC1608','#00B050'],
			isModalVisible: false,
			months:[],
			filterDrawer: false, //used
			filterDrawerDirection: 'rtl',
			monthList:[],
			activeNames: ['1'],
			form: {
				name: '',
				region: '',
				date1: '',
				date2: '',
				delivery: false,
				type: [],
				resource: '',
				desc: ''
			},

			barChartSize: {
				width:500,
				height:500,
			},

			barChartSizeTop: {
				width:500,
				height:200,
			},

			comparisonChart: [],

			tabChartPenerimaanActiveName: 'tabChartPenerimaanPenjualan', //sample
			tabChart: {
				activeName: 'tabChartPenerimaanPenjualan',
				visible: false,
				tab1: true,
				tab2: false,
				tab3: false,
				tab4: false,
			},

			filterParam: {
				dataType: 'total',
				comparisonChartVisibility: false
			},

			//new filter
			tabPenerimaanActiveName: 'first',
			kategori: {
				penerimaan: {
					checked: ['Penjualan'],
				},
				persentasePenerimaan: {
					checked: ['Penjualan'],
				},
				pengeluaran: {
					checked: ['Pengeluaran'],
				},
				persentasePengeluaran: {
					checked: ['Pengeluaran'],
				},
			},

			label: {
				penerimaan: {
					penjualan: {
						checked: [],
					},
					bunga_deposito: {
						checked: [],
					},
					bunga_giro: {
						checked: [],
					},
					bunga_notpool: {
						checked: [],
					},
				},
				persentasePenerimaan: {
					cash: {
						checked: [],
					},
					non_cash: {
						checked: [],
					},
					cash_per_day: {
						checked: [],
					},
					non_cash_per_day: {
						checked: [],
					},
					penjualan: {
						checked: [],
					},
					rata_rata_day: {
						checked: [],
					},
				},
				pengeluaran: {
					bank_charge: {
						checked: [],
					},
					biaya_administrasi_bank: {
						checked: [],
					},
					pajak_giro: {
						options: [],
					},
					pajak_notpool: {
						checked: [],
					},
					pengeluaran: {
						checked: [],
					},
				},
				persentasePengeluaran: {
					pengeluaran: {
						checked: [],
					},
					bank_charge: {
						checked: [],
					},
					biaya_administrasi_bank: {
						checked: [],
					},
					pengeluaran_per_bank: {
						checked: [],
					},
					pajak_giro: {
						checked: [],
					},
				},
			},

			month: {
				checked: [],
			},

			year: {
				checked: [],
			},

			pieChartCashNonCashData: {},

			//cascader
			props: { multiple: true, checkStrictly: false },
			options: [
				{
					value: 1,
					label: 'Penerimaan',
					children: [
						{
							value: 2,
							label: 'Penjualan',
							children: [],
						}, 
						{
							value: 6,
							label: 'Bunga Deposito',
							checkStrictly: true,
							children: [
								{ value: 7, label: 'BCA - PT. Bank Central Asia Tbk',  },
								{ value: 8, label: 'BNI' },
								{ value: 9, label: 'BRI' }
							]
						}, 
						{
							value: 10,
							label: 'Bunga Giro',
							children: [
								{ value: 11, label: 'BCA PEMBIAYAAN' },
								{ value: 12, label: 'BCA PENAMPUNGAN' },
								{ value: 13, label: 'BCA UTAMA' }
							]
						},
						{
							value: 10,
							label: 'Bunga Notpool',
							children: [
								{ value: 11, label: 'BRI' },
								{ value: 12, label: 'MANDIRI' },
								{ value: 13, label: 'BNI' }
							]
						},
					]
				},
				{
					value: 14,
					label: 'Persentase Penerimaan',
					children: [
						{
							value: 15,
							label: 'Cash',
							children: [
								{ value: 16, label: 'BCA' },
								{ value: 17, label: 'BRI' },
								{ value: 18, label: 'BNI' }
							]
						},
						{
							value: 19,
							label: 'Non Cash',
							children: [
								{ value: 20, label: 'BCA' },
								{ value: 21, label: 'BNI' },
								{ value: 22, label: 'BRI' }
							]
						}
					]
				},
				{
					value: 23,
					label: 'Pengeluaran',
					children: [
						{
							value: 24,
							label: 'Pengeluaran',
							children: [
							{ value: 25, label: 'Advance e toll' },
							{ value: 26, label: 'BIAYA PICK UP' },
							{ value: 27, label: 'BPJS' }
							]
						},
						{
							value: 28,
							label: 'Biaya Administrasi',
							children: [
								{ value: 29, label: 'BCA BRIGHT' },
								{ value: 30, label: 'BCA EDC' },
								{ value: 31, label: 'BCA EDC BRIGHT' }
							]
						}
					]
				},
				{
					value: 23,
					label: 'Persentase Pengeluaran',
					children: [
						{
							value: 24,
							label: 'Pengeluaran',
							children: [
								{ value: 25, label: 'BIAYA PICK UP' },
								{ value: 26, label: 'SPD / Advance' },
								{ value: 27, label: 'Internal' }
							]
						},
						{
							value: 28,
							label: 'Pengeluaran Per Bank',
							children: [
								{ value: 29, label: 'BSI' },
								{ value: 30, label: 'BTN' },
								{ value: 31, label: 'BRI' }
							]
						}
					]
				},
			],
			loading: {
				comparison: false,
			},
			
/*
			dataposition: {
				balanceposition: [],
				cf: [],
				cashnoncash: [],
				covenant: [],
				bunga: [],
				financialratio: [],
				bungachartdata: [],
			},

			financialratioshowtype: 'table',
			pendapatanbungashowtype: 'table',
			*/
		}
	},
	watch: {
        $route(to, from) {
            this.hideNonChildren();
        }
	},
	methods:{
		hideNonChildren() {
            this.isChildRoute = this.$route.path !== '/treasury';
        },

		//new filter
		handleKategoriCheckAllChange(data) {
			let val = data.checkAll;
			//console.log('val: ' + val); //true or false
			data.checked = val ? data.options : [];
			data.isIndeterminate = false;

			//manual
			//this.kategori.penerimaan.checked = val ? this.kategori.penerimaan.options : [];
			//this.kategori.penerimaan.isIndeterminate = false;
		},

		handleKategoriCheckedChange(data) {
				let value = data.checked;
				//console.log('value: ' + JSON.stringify(value));
				let checkedCount = value.length;
				data.checkAll = checkedCount === data.options.length;
				data.isIndeterminate = checkedCount > 0 && checkedCount < data.options.length;

				//manual
				//this.kategori.penerimaan.checkAll = checkedCount === this.kategori.penerimaan.options.length;
				//this.kategori.penerimaan.isIndeterminate = checkedCount > 0 && checkedCount < this.kategori.penerimaan.options.length;
		},
			
		isExistInArray(array, searchElement, fromIndex) {
			//console.log('array: '+array)
			let result = array.map(function(value) { 
				return value.toLowerCase();
			}).indexOf(searchElement.toLowerCase(), fromIndex);

			if (result !== -1)
				return true;

			return false;
		},

		loadMonths() {
			for (let i = 0; i <= 11; i++) {
				//console.log("month: " +i);
				let month = { Id: i+1, Name: this.month.list[i], Grup: 1}
				this.month.options.push(month);
				this.month.checked.push(month);
			} 
		},

		async loadSummaryLabel() {         
			let url = Config().apiURL + "/finance/treasury-label?";
			await AxiosWithJar().get(url).then(result => {
				this.year.options = result.data.years;

				this.label.penerimaan.penjualan.options = result.data.penerimaan.penjualan;
				this.label.penerimaan.bunga_deposito.options = result.data.penerimaan.bunga_deposito;
				this.label.penerimaan.bunga_giro.options = result.data.penerimaan.bunga_giro;
				this.label.penerimaan.bunga_notpool.options = result.data.penerimaan.bunga_notpool;

				this.label.pengeluaran.bank_charge.options = result.data.pengeluaran.bank_charge;
				this.label.pengeluaran.biaya_administrasi_bank.options = result.data.pengeluaran.biaya_administrasi_bank;
				this.label.pengeluaran.pajak_giro.options = result.data.pengeluaran.pajak_giro;
				this.label.pengeluaran.pajak_notpool.options = result.data.pengeluaran.pajak_notpool;
				this.label.pengeluaran.pengeluaran.options = result.data.pengeluaran.pengeluaran;

				this.label.persentasePenerimaan.cash.options = result.data.penerimaan_persentase.cash;
				this.label.persentasePenerimaan.cash_per_day.options = result.data.penerimaan_persentase.cash_per_day;
				this.label.persentasePenerimaan.non_cash.options = result.data.penerimaan_persentase.non_cash;
				this.label.persentasePenerimaan.non_cash_per_day.options = result.data.penerimaan_persentase.non_cash_per_day;
				this.label.persentasePenerimaan.penjualan.options = result.data.penerimaan_persentase.penjualan;
				this.label.persentasePenerimaan.rata_rata_day.options = result.data.penerimaan_persentase.rata_rata_day;

				this.label.persentasePengeluaran.pengeluaran.options = result.data.pengeluaran_persentase.pengeluaran;
				this.label.persentasePengeluaran.bank_charge.options = result.data.pengeluaran_persentase.bank_charge;
				this.label.persentasePengeluaran.biaya_administrasi_bank.options = result.data.pengeluaran_persentase.biaya_administrasi_bank;
				this.label.persentasePengeluaran.pengeluaran_per_bank.options = result.data.pengeluaran_persentase.pengeluaran_per_bank;
				this.label.persentasePengeluaran.pajak_giro.options = result.data.pengeluaran_persentase.pajak_giro;
				
				this.options[0].children[0].children = this.label.penerimaan.penjualan.options;
			})
		}, 
		
		async loadSummaryFilter(table, paramKategori, paramLabels, paramType) {  
			//let currentYear = new Date().getFullYear() + '';     
			//this.selected_current_year = (param_year == "" ? currentYear : param_year );  
			
			let url = Config().apiURL + "/finance/treasury-summary-filter?"
			//url += "&months=" + this.month.checked
			//url += "&years=" + this.year.checked
			//url += "&data_type=" + this.filterParam.dataType
			url += "&source=" + table
			url += "&data_type=" + paramType //total, detail
			url += "&kategori=" + paramKategori
			//url += "&label=" + paramLabels

			let months = this.month.checked
			let years = this.year.checked

			for(let x in months) {
				url += "&months[]=" + encodeURIComponent(months[x].Id + '');
				//console.log('month: ' + months[x].Id)
			}

			for(let y in years) {
				url += "&years[]=" + encodeURIComponent(years[y].Id + '');
				//console.log('year: ' + years[y].Id)
			}

			for(let i in paramLabels) {
				url += "&labels[]=" + encodeURIComponent(paramLabels[i].Nama); //console.log('i : ' + paramLabels[i]);
			}

			await AxiosWithJar().get(url)
			.then(result => {
				//if (result.data.length) {
				try {
					this.setBarchartValue(result.data.data, table, paramKategori)
				} catch(error) {
					//console.log(error);
				}
			});
		},

		async loadSummaryPie(table, paramKategori, paramLabels, paramType) {  
			//let currentYear = new Date().getFullYear() + '';     
			//this.selected_current_year = (param_year == "" ? currentYear : param_year );  
			
			let url = Config().apiURL + "/finance/treasury-summary-pie?"
			//url += "&months=" + this.month.checked
			//url += "&years=" + this.year.checked
			//url += "&data_type=" + this.filterParam.dataType
			url += "&source=" + table
			url += "&data_type=" + paramType //total, detail
			url += "&kategori=" + paramKategori
			//url += "&label=" + paramLabels

			let months = this.month.checked
			let years = this.year.checked

			for(let x in months) {
				url += "&months[]=" + encodeURIComponent(months[x].Id + '');
				//console.log('month: ' + months[x].Id)
			}

			for(let y in years) {
				url += "&years[]=" + encodeURIComponent(years[y].Id + '');
				//console.log('year: ' + years[y].Id)
			}

			for(let i in paramLabels) {
				url += "&labels[]=" + encodeURIComponent(paramLabels[i].Nama); //console.log('i : ' + paramLabels[i]);
			}

			await AxiosWithJar().get(url)
			.then(result => {
				//if (result.data.length) {
				try {
					this.setPiechartValue(result.data.data, table, paramKategori)
				} catch(error) {
					//console.log(error);
				}
			});
		},

		async loadSummaryComparison(kategori, label) {  
			let url = Config().apiURL + "/finance/treasury-summary-comparison?"
			//url += "&source=" + table
			//url += "&label=" + paramLabels

			let months = this.month.checked
			let years = this.year.checked

			for(let x in months) {
				url += "&months[]=" + encodeURIComponent(months[x].Id + '');
				//console.log('month: ' + months[x].Id)
			}

			for(let y in years) {
				url += "&years[]=" + encodeURIComponent(years[y].Id + '');
				//console.log('year: ' + years[y].Id)
			}

			//all kategori penerimaan
			let allKategoriPenerimaan = kategori.penerimaan.checked
			//console.log('allKategoriPenerimaan: ' + JSON.stringify(allKategoriPenerimaan))
			for(let i in allKategoriPenerimaan) {
				url += "&kategoripenerimaan[]=" + encodeURIComponent(allKategoriPenerimaan[i]); //console.log('i : ' + paramLabels[i]);
			}

			//all kategori penerimaan
			let allKategoriPengeluaran = kategori.pengeluaran.checked
			//console.log('allKategoriPengeluaran: ' + JSON.stringify(allKategoriPengeluaran))
			for(let i in allKategoriPengeluaran) {
				url += "&kategoripengeluaran[]=" + encodeURIComponent(allKategoriPengeluaran[i]); //console.log('i : ' + paramLabels[i]);
			}

			//all label penerimaan
			let allLabelPenerimaan = (label.penerimaan.penjualan.checked).concat(label.penerimaan.bunga_deposito.checked, label.penerimaan.bunga_notpool.checked, label.penerimaan.bunga_giro.checked)
			//console.log('allLabelPenerimaan: ' + JSON.stringify(allLabelPenerimaan))
			for(let i in allLabelPenerimaan) {
				url += "&labelpenerimaan[]=" + encodeURIComponent(allLabelPenerimaan[i].Nama); //console.log('i : ' + paramLabels[i]);
			}

			//all label pengeluaran
			let allLabelPengeluaran = (label.pengeluaran.bank_charge.checked).concat(label.pengeluaran.pajak_giro.checked, label.pengeluaran.biaya_administrasi_bank.checked, label.pengeluaran.pajak_notpool.checked, label.pengeluaran.pengeluaran.checked)
			for(let i in allLabelPengeluaran) {
				url += "&labelpengeluaran[]=" + encodeURIComponent(allLabelPengeluaran[i].Nama); //console.log('i : ' + paramLabels[i]);
			}

			this.loading.comparison = true;
			await AxiosWithJar().get(url)
			.then(result => {
				//if (result.data.length) {
				try {
					this.comparisonChart = this.processBarChart(result.data.data, "Legend", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, false, false, false)
				} catch(error) {
					//console.log(error);
				}
			})
			.catch(error => {
					//console.log(error)
                    let errMsg = error
                    this.$alert(errMsg, 'Error', {
                        confirmButtonText: 'Close',
                        callback: action => {
                            this.$message({
                            type: 'danger',
                            message: `Can not load comparison data.\nPlease try again.`
                            });
                        }
                    });
				})
				.finally(() => {
					this.loading.comparison = false;
				});
		},

		async loadSummaryPersentasePenerimaanCashNonCash(kategori, label) {  
			let url = Config().apiURL + "/finance/treasury-summary-cash?"
			//url += "&source=" + table
			//url += "&label=" + paramLabels

			let months = this.month.checked
			let years = this.year.checked

			for(let x in months) {
				url += "&months[]=" + encodeURIComponent(months[x].Id + '');
				//console.log('month: ' + months[x].Id)
			}

			for(let y in years) {
				url += "&years[]=" + encodeURIComponent(years[y].Id + '');
				//console.log('year: ' + years[y].Id)
			}

			//all kategori penerimaan
			let allLabelPenerimaanCashNonCash = label.persentasePenerimaan.cash.checked.concat(label.persentasePenerimaan.non_cash.checked)
			//console.log('allKategoriPenerimaan: ' + JSON.stringify(allKategoriPenerimaan))
			for(let i in allLabelPenerimaanCashNonCash) {
				url += "&labels[]=" + encodeURIComponent(allLabelPenerimaanCashNonCash[i].Nama); //console.log('i : ' + paramLabels[i]);
			}

			await AxiosWithJar().get(url)
			.then(result => {
				//if (result.data.length) {
				try {
					this.pieChartCashNonCashData = result.data.data
					//console.log('this.pieChartCashNonCashData: ' + JSON.stringify(this.pieChartCashNonCashData))
				} catch(error) {
					//console.log(error);
				}
			})
			.catch(error => {
					//console.log(error)
                    let errMsg = error
                    this.$alert(errMsg, 'Error', {
                        confirmButtonText: 'Close',
                        callback: action => {
                            this.$message({
                            type: 'danger',
                            message: `Can not load cash and non cash data.\nPlease try again.`
                            });
                        }
                    });
				})
				.finally(() => {
					//this.loading.comparison = false;
				});
		},

		handleCascaderChange(value){
			//console.log('value cascader: ' + value)
			const result = this.$refs.cascader.getCheckedNodes();
			//console.log(result)
		},
		//end new filter
        
        pieChartData(item)
        {
                var warna=[]
                /*
                //EXAMPLE
                warna["DKI"]='#FFB22E'
                warna["BTN"]='#EEFF2E'
                warna["BSI"]='#2EFF54'
                warna["BRI"]='#2EFFAF'
                warna["BNI"]='#2EA8FF'
                warna["Mandiri"]='#852EFE'	
                warna["BCA"]='#FF2ECB'	

                let valueSample = [{
						transtype: "DKI", 
						amount: 1
					},
					{
						transtype: "BTN", 
						amount: 0
					},
                    {
						transtype: "BSI", 
						amount: 0
					},
                    {
						transtype: "BRI", 
						amount: 28
					},
                    {
						transtype: "BNI", 
						amount: 0
					},
                    {
						transtype: "Mandiri", 
						amount: 24
					},
                    {
						transtype: "BCA", 
						amount: 47
					},
                    ];
                */


                let value = [];
                let idx = 0;
                for (var row in item) {
                    //add color
                    warna[item[row].NamaPengeluaran] = Rainbow[idx];//'#FFB22E'

                    //add value
                    let main = {
                        transtype: item[row].NamaPengeluaran, 
						amount: item[row].Nilai,
                    };

                    value.push(main);
                    idx++;
                }

				return this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
        },

        pieChartPenerimaanData(item)
        {
            var warna = []

            let value = [];
            let idx = 0;
            for (var row in item) {
                //add color
                warna[item[row].NamaPenerimaan] = Rainbow[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: item[row].NamaPenerimaan, 
                    amount: item[row].Nilai,
                };

                value.push(main);
                idx++;
            }

            return this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
        },

		pieChartData2(item)
        {
			//console.log('item pieChartData:' + JSON.stringify(item))
            var warna = []

            let value = [];
            let idx = 0;
            for (var row in item) {
                //add color
                warna[item[row].Label] = Rainbow[idx];//'#FFB22E'

                //add value
                let main = {
                    transtype: item[row].Label, 
                    amount: item[row].Nilai,
                };

                value.push(main);
                idx++;
            }

            return this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
        },

        pieChartPenerimaanCashSummary(data)
        {
            var warna = []

            let value = [];
            let idx = 0;
            for (var row in data) {
                
                for(var row2 in data[row]) {
                    //console.log("row2: " + data[row][row2])
                    if(row2 == 0) {
                        //add color
                        warna[data[row][row2].MonthName] = Rainbow[idx]; //'#FFB22E'

                        //add value
                        let main = {
                            transtype: data[row][row2].MonthName, 
                            amount: data[row][row2].Nilai,
                        };

                        value.push(main);
                    }
                }      
                idx++;

            }

            return this.processPieChart(value, "amount", "transtype", 1, 2, warna); 
        },

        filterModal() {
            this.isModalVisible = true;			
            this.$nextTick(() => {
                $('#modal').modal('show');
            });
        },

        closeModal() {			
            this.isModalVisible = false;
            this.$nextTick(() => {
                $('#modal').modal('hide');
            }); 
        },

		//used
		handleCloseFilterDrawer(done) {
			this.filterDrawer = false;
			/*
        this.$confirm('Are you sure you want to close this?')
          .then(_ => {
            done();
          })
          .catch(_ => {}); */
      },

		handleApplyFilterDrawer(params) {
			this.filterDrawer = false;
			//get param and set value from TreasuryFilterDrawer (child component) to parent (this file)
			this.month.checked = params.month.checked
			this.year.checked = params.year.checked
			this.kategori.penerimaan.checked = params.kategori.penerimaan.checked
			this.kategori.persentasePenerimaan.checked = params.kategori.persentasePenerimaan.checked
			this.kategori.pengeluaran.checked = params.kategori.pengeluaran.checked
			this.kategori.persentasePengeluaran.checked = params.kategori.persentasePengeluaran.checked
			this.filterParam.dataType = params.filter.dataType
			this.filterParam.comparisonChartVisibility = params.filter.comparisonChartVisibility
			this.tabChart.visible = params.filter.tabChartPenerimaanVisbility //sample

			this.loadSummaryFilter('penerimaan', 'PENJUALAN', params.label.penerimaan.penjualan.checked, this.filterParam.dataType)
			this.loadSummaryFilter('penerimaan', 'BUNGA DEPOSITO', params.label.penerimaan.bunga_deposito.checked, this.filterParam.dataType)
			this.loadSummaryFilter('penerimaan', 'BUNGA NOTPOOL', params.label.penerimaan.bunga_notpool.checked, this.filterParam.dataType)
			this.loadSummaryFilter('penerimaan', 'BUNGA GIRO', params.label.penerimaan.bunga_giro.checked, this.filterParam.dataType)

			this.loadSummaryFilter('pengeluaran', 'BANK CHARGE', params.label.pengeluaran.bank_charge.checked, this.filterParam.dataType)
			this.loadSummaryFilter('pengeluaran', 'PAJAK GIRO', params.label.pengeluaran.pajak_giro.checked, this.filterParam.dataType)
			this.loadSummaryFilter('pengeluaran', 'BIAYA ADMINISTRASI BANK', params.label.pengeluaran.biaya_administrasi_bank.checked, this.filterParam.dataType)
			this.loadSummaryFilter('pengeluaran', 'PAJAK NOTPOOL', params.label.pengeluaran.pajak_notpool.checked, this.filterParam.dataType)
			this.loadSummaryFilter('pengeluaran', 'PENGELUARAN', params.label.pengeluaran.pengeluaran.checked, this.filterParam.dataType)

			this.loadSummaryFilter('persentase_penerimaan', 'Cash per day', params.label.persentasePenerimaan.cash_per_day.checked, this.filterParam.dataType)
			this.loadSummaryFilter('persentase_penerimaan', 'Non Cash', params.label.persentasePenerimaan.non_cash.checked, this.filterParam.dataType)
			this.loadSummaryFilter('persentase_penerimaan', 'Rata-Rata/ Day', params.label.persentasePenerimaan.rata_rata_day.checked, this.filterParam.dataType)
			this.loadSummaryFilter('persentase_penerimaan', 'PENJUALAN', params.label.persentasePenerimaan.penjualan.checked, this.filterParam.dataType)
			this.loadSummaryFilter('persentase_penerimaan', 'Cash', params.label.persentasePenerimaan.cash.checked, this.filterParam.dataType)
			this.loadSummaryFilter('persentase_penerimaan', 'Non Cash per day', params.label.persentasePenerimaan.non_cash_per_day.checked, this.filterParam.dataType)

			this.loadSummaryFilter('persentase_pengeluaran', 'BANK CHARGE', params.label.persentasePengeluaran.bank_charge.checked, this.filterParam.dataType)
			this.loadSummaryFilter('persentase_pengeluaran', 'PAJAK GIRO', params.label.persentasePengeluaran.pajak_giro.checked, this.filterParam.dataType)
			this.loadSummaryFilter('persentase_pengeluaran', 'BIAYA ADMINISTRASI BANK', params.label.persentasePengeluaran.biaya_administrasi_bank.checked, this.filterParam.dataType)
			this.loadSummaryFilter('persentase_pengeluaran', 'PENGELUARAN PER BANK', params.label.persentasePengeluaran.pengeluaran_per_bank.checked, this.filterParam.dataType)
			this.loadSummaryFilter('persentase_pengeluaran', 'PENGELUARAN', params.label.persentasePengeluaran.pengeluaran.checked, this.filterParam.dataType)

			//piechart
			this.loadSummaryPie('persentase_penerimaan', 'PENJUALAN', params.label.persentasePenerimaan.penjualan.checked, this.filterParam.dataType)
			this.loadSummaryPie('persentase_pengeluaran', 'BANK CHARGE', params.label.persentasePengeluaran.bank_charge.checked, this.filterParam.dataType)
			this.loadSummaryPie('persentase_pengeluaran', 'PAJAK GIRO', params.label.persentasePengeluaran.pajak_giro.checked, this.filterParam.dataType)
			this.loadSummaryPie('persentase_pengeluaran', 'BIAYA ADMINISTRASI BANK', params.label.persentasePengeluaran.biaya_administrasi_bank.checked, this.filterParam.dataType)
			this.loadSummaryPie('persentase_pengeluaran', 'PENGELUARAN PER BANK', params.label.persentasePengeluaran.pengeluaran_per_bank.checked, this.filterParam.dataType)
			this.loadSummaryPie('persentase_pengeluaran', 'PENGELUARAN', params.label.persentasePengeluaran.pengeluaran.checked, this.filterParam.dataType)


			//comparison
			this.loadSummaryComparison(params.kategori, params.label)

			//pie chart persentase penerimaan cash & non cash
			this.loadSummaryPersentasePenerimaanCashNonCash(params.kategori, params.label)

			//this.loadSummaryData(labelsPenerimaan, labelsPengeluaran);
		},

		handleChangeCollapse(val) {
        //console.log(val);
      },

		handleChangeStartMonth() {
			this.getMonths('3-1-2021','8-1-2022');
			//console.log('aaa');
		},

		handleClickTabChartPenerimaan(tab, event) {
			//console.log(tab.label)
			//console.log(tab.$vnode.key) 
			//console.log(tab, event);
			//setTimeout(function () {
			this.$nextTick(() => {
				let tabLabel = tab.label
				if(tabLabel == 'Penjualan') {
					this.tabChart.tab1 = true
					this.tabChart.tab2 = false
					this.tabChart.tab3 = false
					this.tabChart.tab4 = false
				} else if(tabLabel == 'Bunga Deposito') {
					this.tabChart.tab1 = false
					this.tabChart.tab2 = true
					this.tabChart.tab3 = false
					this.tabChart.tab4 = false
				} else if(tabLabel == 'Bunga Notpool') {
					this.tabChart.tab1 = false
					this.tabChart.tab2 = false
					this.tabChart.tab3 = true
					this.tabChart.tab4 = false
				} else if(tabLabel == 'Bunga Giro') {
					this.tabChart.tab1 = false
					this.tabChart.tab2 = false
					this.tabChart.tab3 = false
					this.tabChart.tab4 = true
				}
			});
			//}, 1000);
		},

		setBarchartValue(data, table, kategori) {
			if(table == 'penerimaan' && kategori == 'PENJUALAN') {
				this.ytd.summary.penerimaan.barchart_penjualan = this.barchartData(data);
			} else if(table == 'penerimaan' && kategori == 'BUNGA DEPOSITO') {
				this.ytd.summary.penerimaan.barchart_bunga_deposito = this.barchartData(data);
			} else if(table == 'penerimaan' && kategori == 'BUNGA NOTPOOL') {
				this.ytd.summary.penerimaan.barchart_bunga_notpool = this.barchartData(data);
			} else if(table == 'penerimaan' && kategori == 'BUNGA GIRO') {
				this.ytd.summary.penerimaan.barchart_bunga_giro = this.barchartData(data);
			}

			else if(table == 'pengeluaran' && kategori == 'BANK CHARGE') {
				this.ytd.summary.pengeluaran.barchart_bank_charge = this.barchartData(data);
			} else if(table == 'pengeluaran' && kategori == 'PAJAK GIRO') {
				this.ytd.summary.pengeluaran.barchart_pajak_giro = this.barchartData(data);
			} else if(table == 'pengeluaran' && kategori == 'BIAYA ADMINISTRASI BANK') {
				this.ytd.summary.pengeluaran.barchart_biaya_administrasi_bank = this.barchartData(data);
			} else if(table == 'pengeluaran' && kategori == 'PAJAK NOTPOOL') {
				this.ytd.summary.pengeluaran.barchart_pajak_notpool = this.barchartData(data);
			} else if(table == 'pengeluaran' && kategori == 'PENGELUARAN') {
				this.ytd.summary.pengeluaran.barchart_pengeluaran = this.barchartData(data);
			}

			else if(table == 'persentase_penerimaan' && kategori == 'Cash per day') {
				this.ytd.summary.penerimaan_persentase.barchart_cash_per_day = this.barchartData(data);
			} else if(table == 'persentase_penerimaan' && kategori == 'Non Cash') {
				this.ytd.summary.penerimaan_persentase.barchart_non_cash = this.barchartData(data);
			} else if(table == 'persentase_penerimaan' && kategori == 'Rata-Rata/ Day') {
				this.ytd.summary.penerimaan_persentase.barchart_rata_rata_day = this.barchartData(data);
			} else if(table == 'persentase_penerimaan' && kategori == 'PENJUALAN') {
				this.ytd.summary.penerimaan_persentase.barchart_penjualan = this.barchartData(data);
			} else if(table == 'persentase_penerimaan' && kategori == 'Cash') {
				this.ytd.summary.penerimaan_persentase.barchart_cash = this.barchartData(data);
			} else if(table == 'persentase_penerimaan' && kategori == 'Non Cash per day') {
				this.ytd.summary.penerimaan_persentase.barchart_non_cash_per_day = this.barchartData(data);
			}

			else if(table == 'persentase_pengeluaran' && kategori == 'BANK CHARGE') {
				this.ytd.summary.pengeluaran_persentase.barchart_bank_charge = this.barchartData(data);
			} else if(table == 'persentase_pengeluaran' && kategori == 'PAJAK GIRO') {
				this.ytd.summary.pengeluaran_persentase.barchart_pajak_giro = this.barchartData(data);
			} else if(table == 'persentase_pengeluaran' && kategori == 'BIAYA ADMINISTRASI BANK') {
				this.ytd.summary.pengeluaran_persentase.barchart_biaya_administrasi_bank = this.barchartData(data);
			} else if(table == 'persentase_pengeluaran' && kategori == 'PENGELUARAN PER BANK') {
				this.ytd.summary.pengeluaran_persentase.barchart_pengeluaran_per_bank = this.barchartData(data);
			} else if(table == 'persentase_pengeluaran' && kategori == 'PENGELUARAN') {
				this.ytd.summary.pengeluaran_persentase.barchart_pengeluaran = this.barchartData(data);
			}

		},

		setPiechartValue(data, table, kategori) {
			if(table == 'persentase_penerimaan' && kategori == 'PENJUALAN') {
				this.ytd.summary.piechart_penerimaan_persentase.penjualan = data;
			} else if(table == 'persentase_pengeluaran' && kategori == 'BANK CHARGE') {
				this.ytd.summary.piechart_pengeluaran_persentase.bank_charge = data;
			} else if(table == 'persentase_pengeluaran' && kategori == 'PAJAK GIRO') {
				this.ytd.summary.piechart_pengeluaran_persentase.pajak_giro = data;
			} else if(table == 'persentase_pengeluaran' && kategori == 'BIAYA ADMINISTRASI BANK') {
				this.ytd.summary.piechart_pengeluaran_persentase.biaya_administrasi_bank = data;
			} else if(table == 'persentase_pengeluaran' && kategori == 'PENGELUARAN PER BANK') {
				this.ytd.summary.piechart_pengeluaran_persentase.pengeluaran_per_bank = data;
			} else if(table == 'persentase_pengeluaran' && kategori == 'PENGELUARAN') {
				this.ytd.summary.piechart_pengeluaran_persentase.pengeluaran = data;
			}
		},

		barchartData(data) {
			let result = this.processBarChart(data, "Tahun", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true)
			
			if(this.filterParam.dataType == 'detail')
				result = this.processBarChart(data, "label", "", "Nilai", false, "MonthName", "", 1, 2, Rainbow, "Grup", [1], true)
			
			//console.log('result: ' + JSON.stringify(result))
			return result
		},

		getMonths(startDate, endDate1) {
			var resultList = [];
			var date = new Date(startDate);
			var endDate = new Date(endDate1);
			var monthNameList = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

			while (date <= endDate)
			{
				var stringDate = monthNameList[date.getMonth()] + " " + date.getFullYear();
				
				//get first and last day of month
				var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
				var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
				
				resultList.push({
						str:stringDate,
						first:firstDay,
						last:lastDay,
				});
				date.setMonth(date.getMonth() + 1);
			}
			
			this.monthList = resultList;
			return resultList;
		},

	},
}

</script>

<style>
	.el-row {
    margin-bottom: 2px;
  }

  .el-row:last-child {
      margin-bottom: 0;
    }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 36px;
  }
  .row-bg {
    padding: 10px 0;
    background-color: #f9fafc;
  }

  .title-section {
	padding: 4px 0px;
	margin-bottom: 15px;
	color: #409EFF;
  }

#table-covenant thead td {
	padding: 8px 8px;
	font-size:14px;
}

#table-covenant tbody td {
	padding: 6px 8px;
	color: #606266;
	font-size:14px;
}

#table-covenant tfoot td {
	padding: 6px 8px;
	color: #606266;
	font-weight: bold;
	font-size:15px;
}

.text-title {
	font-size: 18px;
}
</style>